module.exports = __webpack_public_path__ + "img/05.475b455e.png";